<script setup lang="ts">
import { useI18n } from 'vue-i18n';
export type ViewMode = 'cards' | 'table';

const props = defineProps<{
  modelValue: ViewMode;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: ViewMode];
}>();

function toggleViewMode() {
  emit('update:modelValue', props.modelValue === 'cards' ? 'table' : 'cards');
}
const { t } = useI18n();
</script>

<template>
  <div class="view-mode-toggle">
    <button
      type="button"
      class="btn btn_secondary"
      @click="toggleViewMode">
      <!-- Icône Galerie (quand mode actuel = table) -->
      <span
        v-if="modelValue === 'table'"
        class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640">
          <path
            d="M288 144C288 117.5 266.5 96 240 96L144 96C117.5 96 96 117.5 96 144L96 240C96 266.5 117.5 288 144 288L240 288C266.5 288 288 266.5 288 240L288 144zM288 400C288 373.5 266.5 352 240 352L144 352C117.5 352 96 373.5 96 400L96 496C96 522.5 117.5 544 144 544L240 544C266.5 544 288 522.5 288 496L288 400zM352 144L352 240C352 266.5 373.5 288 400 288L496 288C522.5 288 544 266.5 544 240L544 144C544 117.5 522.5 96 496 96L400 96C373.5 96 352 117.5 352 144zM544 400C544 373.5 522.5 352 496 352L400 352C373.5 352 352 373.5 352 400L352 496C352 522.5 373.5 544 400 544L496 544C522.5 544 544 522.5 544 496L544 400z"
            fill="currentColor" />
        </svg>
      </span>
      <!-- Icône Liste (quand mode actuel = cards) -->
      <span
        v-else
        class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640">
          <path
            d="M96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM160 160L160 224L224 224L224 160L160 160zM480 160L288 160L288 224L480 224L480 160zM160 288L160 352L224 352L224 288L160 288zM480 288L288 288L288 352L480 352L480 288zM160 416L160 480L224 480L224 416L160 416zM480 416L288 416L288 480L480 480L480 416z"
            fill="currentColor" />
        </svg>
      </span>
      <span>{{ modelValue === 'cards' ? t('viewMode.list') : t('viewMode.gallery') }}</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.view-mode-toggle {
  display: flex;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 130px;

    .icon {
      width: 2.0rem;
      height: 2.0rem;
      display: block;

      svg {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
@media screen and (max-width:768px) {
  .view-mode-toggle {
    position: sticky;
    bottom: 1.5rem;
    left: -9999px;
    right: -9999px;
    margin: 0 auto;

    .btn {
      color: #fff;
      background-color: #000;
      padding: 1.2rem 1.6rem;
      border-radius: 3rem;
      display: flex;
      align-items: center;
      gap: 0.8rem;
      min-width: auto;
      border: 0;
    }

    .icon {
      width: 1.6rem;
      height: 1.6rem;
      display: block;

      svg {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}

</style>
